import loanFormModel from '../../components/loan_application/form_models/loanFormModel';
import { default as newLoanFormModel } from '../../pages/dashboard/loan_detail/flows/NewWelcomeFlow/form_models/loanFormModel';
import { ValidationSchema } from '../interfaces';
import { Validation } from '../Validation';
import * as Yup from 'yup';
import LoanBalanceValidation from './LoanBalanceValidation';
import LoanYearOfMaturityValidation from './LoanYearOfMaturityValidation';
import LoanMonthlyPaymentValidation from './LoanMonthlyPaymentValidation';
import LoanPurposeValidation from './LoanPurposeValidation';
import LoanLenderValidation from './LoanLenderValidation';
import OutstandingLoanTypeValidation from './OutstandingLoanTypeValidation';
import { DEBT_OBLIGATIONS_SELECT_OPTIONS } from '../../constants';

interface ValidationDocument {
  files?: any[];
}

const {
  formField: { borrowerAttestsNoDebtPick },
} = loanFormModel;

const { debtSchedule } = newLoanFormModel.formField.loanObligationsDocuments;
const { uploadOrListDebtObligations } = newLoanFormModel.formField;

export class MaterialLoanObligationValidation implements ValidationSchema {
  public name = 'outstanding_loans';
  public label = '';
  public dependsOn: string[] = [
    borrowerAttestsNoDebtPick.name,
    uploadOrListDebtObligations.name,
    debtSchedule.name,
  ];
  public type = 'array';
  public required = {
    message: '',
    value: false,
  };
  public nullable = false;

  public when(
    borrowerAttestsNoDebtPick: string,
    uploadOrListDebtObligations: string,
    debtScheduleDoc: ValidationDocument,
    schema: Yup.ArraySchema<Yup.ObjectSchema<any>>
  ) {
    if (
      borrowerAttestsNoDebtPick === 'Yes' &&
      uploadOrListDebtObligations ===
        DEBT_OBLIGATIONS_SELECT_OPTIONS.LIST_OUT_DEBT_OBLIGATIONS
    ) {
      // This validation is for the Loan Obligations section.
      // No matter if the user is paying mortgage and added a Mortgage in section 1, if selects Yes to attest to no debt and
      // selects List out debt obligations, we need to ensure that the user has added at least one loan
      // that is not the one from the section 1 (on_system_property).

      // Validate the manually added outstanding loans that are not the one from the section 1 (on_system_property)
      // sunstone_credit/frontend/src/validations/material_loan_obligation/MaterialLoanObligationValidation.ts
      if (
        borrowerAttestsNoDebtPick === 'Yes' &&
        uploadOrListDebtObligations ===
          DEBT_OBLIGATIONS_SELECT_OPTIONS.LIST_OUT_DEBT_OBLIGATIONS
      ) {
        return schema
          .of(
            Yup.lazy((loan: any) => {
              const nonMortgageItemSchema = Yup.object().shape({
                [LoanLenderValidation.name]: LoanLenderValidation.buildSchema(),
                [OutstandingLoanTypeValidation.name]:
                  OutstandingLoanTypeValidation.buildSchema(),
                [LoanPurposeValidation.name]:
                  LoanPurposeValidation.buildSchema(),
                [LoanBalanceValidation.name]:
                  LoanBalanceValidation.buildSchema(),
                [LoanYearOfMaturityValidation.name]:
                  LoanYearOfMaturityValidation.buildSchema(),
                [LoanMonthlyPaymentValidation.name]:
                  LoanMonthlyPaymentValidation.buildSchema(),
              });

              return loan?.on_system_property !== 'Yes'
                ? nonMortgageItemSchema
                : Yup.object().strip();
            }) as unknown as Yup.AnySchema
          )
          .test(
            'at-least-one-not-on-system-property',
            'Please add at least one loan.',
            (loans: any[] = []) =>
              loans.some((l) => l?.on_system_property !== 'Yes')
          );
      }
    } else if (
      borrowerAttestsNoDebtPick === 'Yes' &&
      uploadOrListDebtObligations ===
        DEBT_OBLIGATIONS_SELECT_OPTIONS.DEBT_SCHEDULE
    ) {
      return schema;
    } else {
      // Check if Debt Schedule file is uploaded
      if (debtScheduleDoc.files) return schema;
      return schema;
    }
  }
}
export default new Validation(new MaterialLoanObligationValidation());
